export default "__VITE_ASSET__8ec29133__"